module.exports = __webpack_public_path__ + "img/phone-icon.07463704.svg";